const mutations = {
  SET_BASIC_SERVICES(state, payload) {
    state.basicServices = payload;
  },
  SET_BASIC_SERVICE(state, payload) {
    state.basicService = payload;
  },
};

export default mutations;